import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash';
import store from 'store/configureStore';

import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';

import VideoStream from '../VideoStream';
import ToggleAudio from '../ToggleAudio';
import ToggleVideo from '../ToggleVideo';

import theme from './LocalVideo.scss';

export default class LocalVideo extends PureComponent {
  static propTypes = {
    isMCU: PropTypes.bool,
    isSwitched: PropTypes.bool,
    isAudioMuted: PropTypes.bool,
    isVideoMuted: PropTypes.bool,
    videoDisabled: PropTypes.bool,
    width: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    height: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),

    setVideoLayout: PropTypes.func.isRequired,
    muteAudio: PropTypes.func.isRequired,
    unmuteAudio: PropTypes.func.isRequired,
    muteVideo: PropTypes.func.isRequired,
    unmuteVideo: PropTypes.func.isRequired,
    getMediaStream: PropTypes.func.isRequired,
  };

  static defaultProps = {
    width: 250,
    height: 140,
    isMCU: false,
    isSwitched: false,
    isAudioMuted: false,
    isVideoMuted: false,
    videoDisabled: false,
  };

  constructor(props) {
    super(props);
    this.state = ({ stream: null });
  }

  componentDidMount() {
    const { getMediaStream } = this.props;

    return getMediaStream()
      .then(stream => this.setState({ stream }));
  }

  componentWillReceiveProps(nextProps) {
    const { getMediaStream } = nextProps;
    const { stream } = this.state;
    const hasSwitched = (nextProps.isSwitched !== this.props.isSwitched);

    if (!hasSwitched && stream && stream.active) {
      return;
    }

    return getMediaStream()
      .then(stream => this.setState({ stream }));
  }

  componentWillUnmount() {
    if (this.state.stream) {
      const tracks = this.state.stream.getTracks();

      tracks.forEach(track => {
        track.stop();
      });

      delete this.state.stream;
    }
  }

  render() {
    const {
      isMCU,
      width,
      height,
      isAudioMuted,
      isVideoMuted,
      videoDisabled,
      muteAudio,
      unmuteAudio,
      muteVideo,
      unmuteVideo,
      isSwitched,
      setVideoLayout,
    } = this.props;

    const { stream } = this.state;

    if (!stream) {
      return '';
    }

    const onClick = () => conferenceInProgress(store.getState())
      ? setVideoLayout(!isSwitched)
      : noop;

    return (
      <Fragment>
        { stream && stream.active
          ? (
            <div className={ theme.root }>
              <div
                className={{ [theme.disabledVideo]: videoDisabled && !isSwitched }}
                onClick={ onClick }
              >
                <VideoStream
                  stream={ stream }
                  width={ width }
                  height={ height }
                  muted={ !isSwitched }
                />
              </div>
              { !isSwitched && !isMCU && (
                <div className={ theme.controls }>
                  <ToggleVideo
                    isActive={ isVideoMuted }
                    activate={ muteVideo }
                    deactivate={ unmuteVideo }
                  />

                  <ToggleAudio
                    isActive={ isAudioMuted }
                    activate={ muteAudio }
                    deactivate={ unmuteAudio }
                  />
                </div>
              ) }
            </div>
          )
          : null
        }
      </Fragment>
    );
  }
}
